import crudConfig from "./crudConfig";
import uiConfig from "./uiConfig";

export {
    crudConfig,
    uiConfig
}